import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import { PushNotificationService } from 'src/app/shared/services/push-notification.service';
import { CommonFunctions } from '../common-functions';
@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagingService {
  currentMessage = new BehaviorSubject(null);
  public isMobile;
  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private _notificationService: PushNotificationService,
    private commonFunction: CommonFunctions
  ) {
    this.isMobile=this.commonFunction.identifyDeviceType()
    this.angularFireMessaging.messages.subscribe(
      (_messaging:any) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    )
  }
  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        localStorage.setItem('firebaseDeviceId', token);
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        this.currentMessage.next(payload);
        this.notify(payload['data']);
      })
  }
  // browser notifications
  notify(push) {
    let data: Array<any> = [];
    data.push({
      'title': push.title,
      'alertContent': push.body,
    });
    let options = {
      body: data[0].alertContent,
      icon: "src/assets/icons/icon-512x512.png",
    };
    if(this.isMobile){
      navigator.serviceWorker.ready.then((SwRegistrationOptions) => {
        SwRegistrationOptions.showNotification(data[0].title,options);
      })
    }else{
      new Notification(data[0].title, options);
    }
  }
}